import { StorageService } from 'app/@core/services/storage.service';
import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, ChangeDetectorRef, HostListener
} from "@angular/core";
import { ROUTES } from './vertical-menu-routes.config';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { of, Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import { BaseService } from 'app/@core/services/base.service';
import { catchError, map } from 'rxjs/operators';
import { IUserRolesResponse,IRole, IUpdatedPreferenceJson } from '../interfaces/companyData.interface';

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = '';
  companyLogoUrl: string;
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  role = this.storageService.getRoles();
  rolesApiUrl: string='user/get-roles-by-email';
  email:string;
  isAdmin: any=false;
  constructor(
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private storageService: StorageService,
    private baseService: BaseService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }

  enableMenu = {
    '/modules': true,
    '/access-management': true
  };

  userType: string = ""
  ngOnInit() {
    const companyPreferences: IUpdatedPreferenceJson = JSON.parse(localStorage.getItem("companyPrefrences"))
    this.email=localStorage.getItem("userEmail");
    this.userType = localStorage.getItem("userType");
    this.menuItems = this.filterEnableMenu();
    this.companyLogoUrl = companyPreferences?.companyLogo && companyPreferences.companyLogo

    // Load Roles 
    if(this.userType!=='Company'){
      this.loadRolesAndSetAdmin(this.email);
    }

    // Subscribe before first view check to avoid changing template-bound values in ngAfterViewInit.
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();
    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });
  }

  private loadRolesAndSetAdmin(email: string): void {
    this.baseService.getUserRoles(this.rolesApiUrl,email).pipe(
      map((user: IUserRolesResponse) =>
        user?.roles?.some((r:IRole) => (r.roleName || '').toLowerCase().includes('admin'))
      ),
      catchError(err => {
        console.error('Failed to get roles', err);
        return of(false);
      })
    ).subscribe(isAdmin => {
      this.isAdmin = isAdmin;
    });
  }

  filterEnableMenu() {
    this.enableMenu['/asset-pools'] = this.storageService.isEnableAssetPool();
    return ROUTES.filter(route => this.enableMenu[route.path]);
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {
    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    }
    else if (this.config.layout.menuPosition === "Side") { // Vertical Menu{
      this.menuItems = this.filterEnableMenu();
    }

    if (this.config.layout.sidebar.backgroundColor === 'white') {
      if (!this.companyLogoUrl) {
        this.logoUrl = 'assets/logo.png';
      }
	  else{
		this.logoUrl = this.companyLogoUrl
	  }
    }
    else {
      let conf = this.config;
      if (conf.layout.sidebar.collapsed) {
        if(!this.companyLogoUrl)
          this.logoUrl = 'assets/img/logos/short-logo.svg';
        else this.logoUrl = ''
      } else {
        if (!this.companyLogoUrl) {
          this.logoUrl = 'assets/img/logos/logo-visibility.png';
        }
		else{
		this.logoUrl = this.companyLogoUrl
	  }
      }

    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    if (conf.layout.sidebar.collapsed) {
      this.logoUrl = null;
    } else {
      if (!this.companyLogoUrl) {
        this.logoUrl = 'assets/img/logo.png';
      }
    }
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }

  showHide() {
    if (this.role === 'Employee') {
      let arr = this.menuItems.filter(item => item.title !== "Settings" && item.title !== "User Access");
      // let arr = this.menuItems.filter(item => item.title !== "EZTrack  Settings" && item.title !== "Access Management");
      this.menuItems = arr;
    }
  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
